import { Link } from "react-router-dom";
import "./styles.css";
import Error404Img from "../../../Assets/img/Error.jpg";
export default function NotFound() {
    return (
        <div className="d-flex flex-column flex-root container-capys">
            <div
                className="d-flex flex-row-fluid flex-column bgi-size-cover bgi-position-center bgi-no-repeat p-10 p-sm-30 "
                style={{ backgroundImage: `url(${Error404Img})` }}
            >
                <div className="align-self-start">
                    <h1
                        className="font-weight-boldest text-dark-75 mt-15 align-self-center text-center"
                        style={{ fontSize: "10rem" }}
                    >
                        404
                    </h1>
                    <p className="font-size-h3 text-muted font-weight-normal">
                        OOPS! Página não encontrada
                    </p>

                    <Link
                        className="btn btn-light-dark font-weight-bold"
                        to="/Geral/Dashboard"
                        style={{ width: "100%" }}
                    >
                        <i className="icon-2x flaticon-layers"></i> Ir para
                        página inicial
                    </Link>
                </div>
            </div>
        </div>
    );
}
